export const importTypes = [
  { id: "PassportTable", name: "Паспортный стол" },
  { id: "MigrationTable", name: "Миграционный стол" },
  { id: "InternalSystem", name: "Внутренняя система" },
  { id: "Zags", name: "ЗАГС" },
  { id: "district", name: "Районный импорт" },
];
